import * as jsonData from './data.json';

/* =========================
   WORKING TYPES (✅ ADDED)
   - Fixes: "No exported member WorkingTabs"
   - Fixes: Object.entries tab is unknown (when you cast tabs as WorkingTabs)
========================= */

export type WorkingTab = {
  name: string;
  icon: string;
  categoryId: string;
};

export type WorkingTabs = Record<string, WorkingTab>;

/* =========================
   INTERFACES
========================= */

export interface HeadingData {
  header: any;
  hero: any;
  apps: any;
  features: any;
  why: any;
  working: any;
  pricing: any;
  contact: any;
  footer: any;
}

export interface SubheadingData {
  hero: any;
  apps: any;
  features: any;
  why: any;
  pricing: any;
}
export interface CoreData {
  hero: any;
  apps: any;
  features: any;
  why: any;
  testimonials: any;
  working: any;
  pricing: any;
  contact: any;
}
export interface CtaButtonsData {
  primary: any;
  secondary: any;
}
export interface UiElementsData {
  navigation: any;
  socialLinks: any;
  footerLinks: any;
}
export interface MediaData {
  logos: any;
  heroScreenshots: any;
  heroTestimonials: any;
  paymentMethods: any;
  office: any;
}
export interface FooterData {
  about: any;
  sections: any;
  toggleText: any;
  socialLinks: any;
  links: any;
  legal: any;
}
export interface MetadataData {
  company: any;
  product: any;
}

/* =========================
   RAW EXPORTS
========================= */

export const HEADINGS = jsonData.headings as HeadingData;
export const SUBHEADINGS = jsonData.subheadings as SubheadingData;
export const CORE_DATA = jsonData.coreData as CoreData;
export const CTA_BUTTONS = jsonData.ctaButtons as CtaButtonsData;
export const ARIA_LABELS = jsonData.ariaLabels;
export const UI_ELEMENTS = jsonData.uiElements as UiElementsData;
export const MEDIA = jsonData.media as MediaData;
export const METADATA = jsonData.metadata as MetadataData;

/* =========================
   LEGACY
========================= */

export const CTA_LINKS = jsonData.ctaButtons.primary;

/* =========================
   HEADER
========================= */

export const HEADER_DATA = {
  logo: jsonData.media.logos.salemobilizer,
  navigation: jsonData.uiElements.navigation,
  ctaButtons: [
    {
      text: jsonData.ctaButtons.primary.meeting.text,
      url: jsonData.ctaButtons.primary.meeting.url,
      target: jsonData.ctaButtons.primary.meeting.target,
      primary: false,
    },
    {
      text: jsonData.ctaButtons.primary.download.text,
      url: jsonData.ctaButtons.primary.download.url,
      target: jsonData.ctaButtons.primary.download.target,
      primary: true,
    },
  ],
};

/* =========================
   HERO
========================= */

export const HOME_HERO_DATA = {
  sharedLinks: {
    meeting: jsonData.ctaButtons.primary.meeting.url,
    download: jsonData.ctaButtons.primary.download.url,
  },
  hero: {
    badge: jsonData.headings.hero.badge,
    title: jsonData.headings.hero.title,
    highlight: jsonData.headings.hero.highlight,
    description: jsonData.subheadings.hero.description,
    videoSrc: jsonData.coreData.hero.videoSrc,
    platformText: jsonData.headings.hero.platformText,
  },
};

/* =========================
   WHY
========================= */

export const HOME_WHY_DATA = {
  features: jsonData.coreData.why,
  testimonials: jsonData.coreData.testimonials,
};

/* =========================
   APPS
========================= */

export const APPS_DATA = {
  header: {
    title: jsonData.headings.apps.title,
    subtitle: jsonData.headings.apps.subtitle,
  },
  apps: jsonData.coreData.apps,
};

/* =========================
   ⭐ FEATURES (FINAL FIX)
========================= */

export const HOME_FEATURES_DATA = jsonData.coreData.features;

export const FEATURES_DATA = {
  header: {
    title: jsonData.headings.features.title,
    subtitle: jsonData.headings.features.subtitle,
  },
};

/* =========================
   WORKING
========================= */

export const HOME_WORKING_DATA = jsonData.coreData.working;

// ✅ typed tabs for components that need WorkingTabs
export const WORKING_TABS = (jsonData.headings.working?.tabs || {}) as WorkingTabs;

export const WORKING_DATA = {
  header: {
    title: jsonData.headings.working.title,
  },
  working: {
    ...jsonData.headings.working,
    // ✅ ensures tabs is strongly typed when consumed
    tabs: WORKING_TABS,
  },
};

/* =========================
   PRICING
========================= */

export const HOME_PRICING_DATA = jsonData.coreData.pricing;

export const PRICING_DATA = {
  header: {
    title: jsonData.headings.pricing.title,
    subtitle: jsonData.headings.pricing.subtitle,
  },
};

/* =========================
   CONTACT
========================= */

export const CONTACT_DATA = {
  ...jsonData.coreData.contact,
  contactUs: jsonData.headings.contact.title,
  socialLinks: jsonData.uiElements.socialLinks,
};

/* =========================
   FOOTER
========================= */

export const FOOTER_DATA = {
  about: {
    logo: jsonData.media.logos.salemobilizer,
    techColleaguesLogo: jsonData.media.logos.techColleagues,
    text: {
      main: jsonData.headings.footer.about,
      additional: jsonData.headings.footer.builtBy,
      companyDescription: jsonData.headings.footer.companyDescription,
    },
  },
  sections: jsonData.headings.footer.sections,
  toggleText: jsonData.headings.footer.toggleText,
  socialLinks: jsonData.uiElements.socialLinks,
  links: jsonData.uiElements.footerLinks,
  legal: {
    copyright: jsonData.metadata.company.copyright,
    payments: jsonData.media.paymentMethods,
  },
};

/* =========================
   HERO EXTRA
========================= */

export const HERO_ADDITIONAL_DATA = {
  screenshots: jsonData.media.heroScreenshots,
  testimonials: jsonData.media.heroTestimonials,
  office: jsonData.media.office,
};